import { GraphSchema } from '@camelot/server';

export interface PaymentLink {
  invoiceId: string;
  executeLink: string;
  executeQrLink: string;
  imageLink: string;
}

export const paymentLinkProps = new GraphSchema<PaymentLink>([
  'invoiceId',
  'executeLink',
  'executeQrLink',
  'imageLink',
]);
